import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AutenticationService } from '../../../../../autentication/autentication.service';
import { Auth } from '../../../../../autentication/Auth';
import { EventTypes } from '../../../../../shared/EventTypes';
import { SharedModalInfoComponent } from '../../../../../shared/modal-info/modal-info.component';
import { AppEventDispatcher } from '../../../../../utils/AppEventDispatcher';
import { Util } from '../../../../../utils/util';
import { PixQrCodeDynamicService } from '../../../copy-and-paste/qr-code-dynamic/qr-code-dynamic.service';
import { PixPaymentFavoredView } from '../../../models/payment-favored-view.model';
import { ETipoOperacao, PixQrCodeReturn } from '../../../models/qr-code-return.model';
import { TipoIniciacaoTransferencia } from '../../../models/tipo-iniciacao-transacao.enum';
import { PixTransferReturnSituacaoTransferencia } from '../../../models/transfer-return.model';
import { PixPaymentKeyService } from '../../../payment-key/payment-key.service';
import { ETipoIniciacao, FiltroChavePixModel, PixWithdrawChangeRequestModel } from '../../models/pix-withdraw-change-request.model';
import { SaqueTrocoModel } from '../../models/pix-withdraw-change-response.model';
import { WithdrawChangeService } from '../../service/withdraw-change.service';
import { MatDialog } from '@angular/material';
import { PixPaymentKeyFavoredCreateDetailComponent } from '../../../payment-key/favored-create/details/details.component';
import { ModalSucessComponent } from '../../../../../shared/modal-sucess/modal-sucess.component';
import * as moment from 'moment';
import { ModalAntifraudWarningComponent } from '../../../../../shared/modal-antifraud-warning/modal-antifraud-warning.component';
@Component({
	selector: 'app-assignature',
	templateUrl: './assignature.component.html',
	styleUrls: ['./assignature.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixWithdrawChangeAssignatureComponent implements OnInit {
	submited: boolean;
	form: FormGroup;
	pixQrCodeReturn: PixQrCodeReturn;
	pixPaymentFavored: PixPaymentFavoredView;
	scheduledPayment = false;
	nameTransfer: string;
	valueTransfer: number;
	dateTransfer: string;
	showAntifraudScreen: boolean;

	constructor(
		private autenticationService: AutenticationService,
		private withdrawChangeService: WithdrawChangeService,
		private pixQrCodeDynamicService: PixQrCodeDynamicService,
		private pixPaymentKeyService: PixPaymentKeyService,
		private router: Router,
		private dialog: MatDialog,) { }

	ngOnInit() {
		this.pixQrCodeReturn = this.pixQrCodeDynamicService.getSelectedPixQrCodeReturn();
		this.pixPaymentFavored =  this.pixPaymentKeyService.getSelectedPixPaymentFavoredView();
	}

	submit(message: boolean) {
		this.submited = message;

		if (this.submited && this.form.valid) {
			this.addAuthToken();
			this.sendAssignature();
		}
	}

	addAuthToken() {
		if (this.form.value.token) {
			Auth.passToken = this.form.value.token;
		}
	}

	addAuthSignature() {
		if (this.form.value.eletronicSignature) {
			Auth.assinaturaEletronica = this.form.value.eletronicSignature;
		}
	}

	sendAssignature() {
		this.autenticationService.sendDigitalSignature(this.form.value.eletronicSignature).subscribe(data => {
			if (data.Sucesso) {
				this.addAuthSignature();
				this.sendRequest();
			}
		}, error => {
			this.handleError(error);
		});
	}

	sendRequest() {
	let request: PixWithdrawChangeRequestModel;

	if (this.pixQrCodeReturn) {
		request = this.generatePixDynamicWithdrawChangeRequestModel();
	} else {
		request = this.generatePixStaticWithdrawChangeRequestModel();
	}

	this.withdrawChangeService.postTransfer(request).subscribe(data => {
		if (data.Sucesso) {
			const result = Util.keysToCamel(data.Retorno) as SaqueTrocoModel;
			this.processResult(result, request);
		}
		}, error => {
			this.handleError(error);
		});
	}

	private processResult(result: SaqueTrocoModel, request: PixWithdrawChangeRequestModel) {
		switch (result.contaPagamento.situacaoTransferenciaPix) {
			case PixTransferReturnSituacaoTransferencia.AGUARDANDO_AUTORIZACAO:
				this.openInfoModal(result, request);
				break;
			case PixTransferReturnSituacaoTransferencia.AUTORIZADA_AGUARDANDO_EFETIVACAO:
				this.openInfoModal(result, request);
				break;
			case PixTransferReturnSituacaoTransferencia.TRANSFERENCIA_REALIZADA:
				 this.generateReceipt(result);
				break;
			case PixTransferReturnSituacaoTransferencia.AGUARDANDO_CONFIRMACAO_IF_DESTINO:
				this.openModal(
					'Estamos processando essa transação',
					'Essa transação esta demorando um pouco mais que o normal',
					'Assim que ela for concluída, ele estará disponível no Extrato. Caso contrário, consulte o item em Transações não realizadas no menu Transações',
					'Entendi');
				break;
				case PixTransferReturnSituacaoTransferencia.TRANSFERENCIA_REPROVADA:
					this.openModal('Transação não concluída', '', result.contaPagamento.mensagem);
					break;
				case PixTransferReturnSituacaoTransferencia.TRANSFERENCIA_EXPIRADA:
					this.openModal('Transação não concluída', '', result.contaPagamento.mensagem);
					break;
				case PixTransferReturnSituacaoTransferencia.ERRO_TRANSFERENCIA:
					this.openModal('Transação não concluída', '', result.contaPagamento.mensagem);
					break;
				case PixTransferReturnSituacaoTransferencia.REJEITADA_IF_DESTINO:
					this.openModal('Transação não concluída', '', result.contaPagamento.mensagem);
					break;
				case PixTransferReturnSituacaoTransferencia.CANCELADA_TESOURARIA:
					this.openModal('Transação não concluída', '', result.contaPagamento.mensagem);
					break;
				case PixTransferReturnSituacaoTransferencia.CANCELADA_CLIENTE:
					this.openModal('Transação não concluída', '', result.contaPagamento.mensagem);
					break;
				case PixTransferReturnSituacaoTransferencia.AGUARDANDO_ANALISE_ANTIFRAUDE:
					this.setDataAntifraudScreen(request);
					break;
				case PixTransferReturnSituacaoTransferencia.CANCELADA_SUSPEITA_FRAUDE:
					this.router.navigate([""], { skipLocationChange: true });
					this.dialog.open(ModalAntifraudWarningComponent, {
						data: []
					});
					break;
			default:
				break;
		}
	}
	private openInfoModal(result: SaqueTrocoModel, request: PixWithdrawChangeRequestModel) {

		this.dialog.open(PixPaymentKeyFavoredCreateDetailComponent, {
			width: '400px', data: {
				situacaoTransferencia: result.contaPagamento.sequenciaTransferencia,
				nome: request.nomeBeneficiario,
				valor: request.valor,
				dataContabil: new Date(),
				complemento: request.descricao,
				codigoTransacao: result.contaPagamento !== undefined ? result.contaPagamento.sequenciaTransferencia : null,
				agendado: this.scheduledPayment
			}
		}).afterClosed().subscribe(res => {
			if (res === undefined) {
				this.router.navigate(['pix']);
			}
		});
	}

	private generatePixDynamicWithdrawChangeRequestModel() {
		const model = new PixWithdrawChangeRequestModel();

		model.valor = this.pixQrCodeReturn.valor;
		model.agenciaBeneficiario = this.pixQrCodeReturn.conta.numeroAgencia;
		model.chavePix = new FiltroChavePixModel();
		model.chavePix.codigo = this.pixQrCodeReturn.chavePix.codigo;
		model.chavePix.tipoChave = this.pixQrCodeReturn.chavePix.tipoChave;
		model.codigoFimAFim = this.pixQrCodeReturn.codigoFimAFim;
		model.codigoQrCode = this.pixQrCodeReturn.codigoTransacao;
		model.codigoRequisicao = Util.generateUUID4();
		model.descricao = this.withdrawChangeService.getDescription();
		model.documentoBeneficiario = this.pixQrCodeReturn.conta.documento;
		model.ispbCodigo = this.pixQrCodeReturn.conta.iSPBCodigo;

		model.nomeBeneficiario = this.pixQrCodeReturn.conta.nome;
		model.numeroContaBeneficiario = this.pixQrCodeReturn.conta.numeroConta.toString();
		model.numeroOrigem = null;

		model.tipoContaBeneficiario = this.pixQrCodeReturn.conta.tipoConta;
		model.tipoIniciacao = ETipoIniciacao.QRCODE_DINAMICO;
		model.tipoIniciacaoTransferencia = TipoIniciacaoTransferencia.QRCODE;

		model.tipoOperacao = this.pixQrCodeReturn.qrCodeDinamico.tipoOperacao;

		if (model.tipoOperacao === ETipoOperacao.TROCO) {
			model.valorCompra = this.pixQrCodeReturn.qrCodeDinamico.troco.compra;
			model.valorTroco = this.pixQrCodeReturn.qrCodeDinamico.troco.troca;
			model.tipoAgente = this.pixQrCodeReturn.qrCodeDinamico.troco.tipoAgente;
			model.ispbFornecedor = this.pixQrCodeReturn.qrCodeDinamico.troco.ispbServico;
		}

		if (model.tipoOperacao === ETipoOperacao.SAQUE) {
			model.valorSaque = this.pixQrCodeReturn.valor;
			model.tipoAgente = this.pixQrCodeReturn.qrCodeDinamico.saque.tipoAgente;
			model.ispbFornecedor = this.pixQrCodeReturn.qrCodeDinamico.saque.ispbServico;
		}

		return model;
	}

	private generatePixStaticWithdrawChangeRequestModel() {
		const model = new PixWithdrawChangeRequestModel();

		model.valor = this.pixPaymentFavored.valorQrCode;
		model.agenciaBeneficiario = this.pixPaymentFavored.numeroAgencia;
		model.chavePix = new FiltroChavePixModel();
		model.chavePix.codigo = this.pixPaymentFavored.codigo;
		model.chavePix.tipoChave = this.pixPaymentFavored.tipoChave;
		model.codigoFimAFim = this.pixPaymentFavored.codigoFimAFim;
		model.codigoQrCode = this.pixPaymentFavored.codigoTransacaoQrCode;
		model.codigoRequisicao = Util.generateUUID4();
		model.descricao = this.withdrawChangeService.getDescription();
		model.documentoBeneficiario = this.pixPaymentFavored.documento;
		model.ispbCodigo = this.pixPaymentFavored.iSPBCodigo;

		model.ispbFornecedor = this.pixPaymentFavored.ispbServico;

		model.nomeBeneficiario = this.pixPaymentFavored.nome;
		model.numeroContaBeneficiario = this.pixPaymentFavored.numeroConta.toString();
		model.numeroOrigem = null;

		model.tipoContaBeneficiario = this.pixPaymentFavored.tipoConta;
		model.tipoIniciacao = ETipoIniciacao.QRCODE_ESTATICO;
		model.tipoIniciacaoTransferencia = TipoIniciacaoTransferencia.QRCODE;
		model.tipoOperacao = this.pixPaymentFavored.tipoOperacao;

		if (model.tipoOperacao === ETipoOperacao.SAQUE) {
			model.valorSaque = this.pixPaymentFavored.valorQrCode;
			model.tipoAgente = this.pixPaymentFavored.tipoAgente;
		}

		return model;
	}

	private openModal(title: string, topText: string, text: string, btnName = 'Fechar', btnBackName = '') {
		const dialogRef = this.dialog.open(SharedModalInfoComponent, {
			width: '420px',
			data: {
				title: title,
				topText: topText,
				text: text,
				btnName: btnName,
				btnBackName: btnBackName
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			this.router.navigate(['pix']);
		});
	}

	private abrirDialogSucesso(result: SaqueTrocoModel, request: PixWithdrawChangeRequestModel) {
		return this.dialog.open(ModalSucessComponent, {
			width: '350px',
			data: {
				title: result.contaPagamento.mensagem,
				topText:
					`<img src="../../../../../assets/success.svg" alt="Success" class="icone-sucesso"/>`,
				text: `
					<div><span><b>R$ ${(request.valor.toString().replace('.', ','))}</b> foi enviado via pix para <b>${request.nomeBeneficiario}</b></span></div>
					<div><span>${moment(new Date()).format('DD/MM/YYYY [-] HH:mm')}</span></div>
				`,
				backButton: '',
				confirmButton: 'Extrato e devoluções',
			}
		});
	}

	private generateReceipt(result: SaqueTrocoModel) {
		this.router.navigate(['pix/comprovante/' + result.codigoTransacao + '/pix']);
	}

	handleError = (error) => {
		AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		this.router.navigate(['pix/pagamento/pix-copia-cola']);
	}

	onSetSignatureForm = (form: FormGroup) => this.form = form;

	setDataAntifraudScreen(request: PixWithdrawChangeRequestModel): void {
		this.nameTransfer = Util.camelCaseText(request.nomeBeneficiario);
		this.valueTransfer = request.valor;
		this.dateTransfer = moment().format('DD/MM/YYYY');
		this.showAntifraudScreen = true;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/withdraw-change/copy-and-paste/assignature/assignature.component.ts